import { EWeekday } from "./date";
import { IRecipe } from "./recipe";
import { IHousehold, IUser } from "./user";

export enum EMeal {
  Breakfast = "Breakfast",
  LunchStarter = "Lunch Starter",
  Lunch = "Lunch",
  DinnerStarter = "Dinner Starter",
  Dinner = "Dinner",
}

export const Meals = [
  EMeal.Breakfast,
  EMeal.LunchStarter,
  EMeal.Lunch,
  EMeal.DinnerStarter,
  EMeal.Dinner,
]

export interface IMealPlan {
  user: IUser;
  date: string;
  meal: EMeal;
  recipe: IRecipe;
  number_people: number;
  is_leftovers: boolean;
}

export interface IMealPlanTemplate {
  household: IHousehold;
  user: IUser;
  template_id: number;
  meal: EMeal;
  weekday: EWeekday;
  recipe: IRecipe;
  number_people: number;
  is_leftovers: boolean;
}
